import { createSlice } from '@reduxjs/toolkit';

export const ResultTipoNovedadSlice = createSlice({
    name: 'resultTipoNovedad',
    initialState: {
        resultTipoNovedades_list: [],
        resultTipoNovedad: {},
        resultTipoNovedadesSelect: [],
    },
    reducers: {
        setResultTipoNovedadesRedux: ( state, { payload } ) => {
            state.resultTipoNovedades_list  =  payload;
        }, 
        storeResultTipoNovedadRedux: ( state, { payload } ) => {
            state.resultTipoNovedad  =  payload;
        },
        storeResultTipoNovedadSelectRedux: ( state, { payload } ) => {
            state.resultTipoNovedadesSelect  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setResultTipoNovedadesRedux, storeResultTipoNovedadRedux, storeResultTipoNovedadSelectRedux } = ResultTipoNovedadSlice.actions;